import D from "debug";
import usuarioApi from "./usuario.api.js";

const debug = D("ciris:usuario");

const state = {
  usuario: {},
};

const actions = {
  getID,
  getBase,
  putID,
  postBase,
  deleteID,
  guardar,
};

const mutations = {
  setUsuario,
  resetUsuario,
};


const store = {
  state,
  actions,
  mutations,
  namespaced: true,
};

export default store;

// actions

function getID(context, params) {
  debug("getID");
  const { id } = params;
  return usuarioApi.getID(id)
    .then((resp) => {
      context.commit("setUsuario", resp);
      return resp;
    })
    .catch(err => debug(err));
}

function getBase(context, params) {
  debug("getBase");
  const { pagina, cantidad } = params;
  return usuarioApi.getBase(pagina, cantidad)
    .then((resp) => {
      context.commit("setUsuarios", resp);
      return resp;
    })
    .catch(err => debug(err));
}

function putID(context, params) {
  debug("putID");
  const { usuario, conservar } = params;
  return usuarioApi.putID(usuario)
    .then((resp) => {
      if (conservar) context.commit("setUsuario", resp);
      return resp;
    })
    .catch(err => debug(err));
}

function postBase(context, params) {
  debug("postBase");
  const { usuario, conservar } = params;
  return usuarioApi.postBase(usuario)
    .then((resp) => {
      if (conservar) context.commit("setUsuario", resp);
      return resp;
    })
    .catch(err => debug(err));
}

function deleteID(context, params) {
  debug("deleteID");
  const { usuario, delLocal } = params;
  return usuarioApi.deleteID(usuario._id)
    .then(() => {
      if (delLocal) context.commit("setUsuario", null);
      return null;
    })
    .catch(err => debug(err));
}

function guardar(context, params) {
  debug("guardar");
  const { usuario, conservar } = params;
  return usuarioApi.guardar(usuario)
    .then((resp) => {
      if (conservar) context.commit("setUsuario", resp);
      return resp;
    })
    .catch(err => debug(err));
}

// mutations

function setUsuario(pState, usuario) {
  debug("setUsuario");
  pState.usuario = usuario;
}

function resetUsuario(pState) {
  debug("resetUsuario");
  pState.usuario = {};
}
